import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../../i18n';
import HybridActivityPointCard from './HybridActivityPointCard';

import s from './HybridActivityClusterCard.module.scss';

/**
 * The pinned card for a cluster that cannot split by zooming: the point's own
 * card, paged through the cluster's points the way the holdings map's
 * PopupCarousel pages through a cluster of holdings — and in its words, so the
 * two carousels read as the same control.
 *
 * Clusters never mix layers — each layer clusters in its own source — so one
 * layer dresses every page.
 */
const HybridActivityClusterCard = ({ items = [], layer }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePrevious = () =>
        setCurrentIndex((index) =>
            index === 0 ? items.length - 1 : index - 1
        );

    const handleNext = () =>
        setCurrentIndex((index) =>
            index === items.length - 1 ? 0 : index + 1
        );

    return (
        <HybridActivityPointCard
            properties={items[currentIndex]}
            layer={layer}
            isPinned
            footer={
                <div className={s.Nav}>
                    <button
                        type="button"
                        className={s.NavButton}
                        onClick={handlePrevious}>
                        {t('map.previous')}
                    </button>
                    <span className={s.Counter}>
                        {t('map.locationCount', {
                            current: currentIndex + 1,
                            total: items.length,
                        })}
                    </span>
                    <button
                        type="button"
                        className={s.NavButton}
                        onClick={handleNext}>
                        {t('map.next')}
                    </button>
                </div>
            }
        />
    );
};

HybridActivityClusterCard.propTypes = {
    // The dataset rows behind the cluster's points, straight off its leaves.
    items: PropTypes.arrayOf(PropTypes.object),
    // The configured layer the cluster belongs to, as the CMS authored it.
    layer: PropTypes.shape({
        name: PropTypes.string,
        icon: PropTypes.string,
        colour: PropTypes.string,
    }),
};

export default HybridActivityClusterCard;
